import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(menuAnatomy.keys);

export const Menu = defineMultiStyleConfig({
	baseStyle: {
		divider: {
			my: 1,
		},

		item: {
			borderRadius: 'sm',
			transitionDuration: 'normal',
			transitionProperty: 'common',

			_hover: {
				bg: 'secondary.bgAlpha',
			},
			_focus: {
				bg: 'secondary.bgAlpha',
			},
		},

		list: {
			p: 1,
		},
	},
});
